import { useEffect, useMemo, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { O, PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { operationHelpers } from "../../../../operations"
import { PurchaseOrder, Supplier } from "../../../state/types"
import { useSupplierLoaders } from "../../../loaders/supplierLoaders"
import { PurchaseForm } from "./purchaseForm"
import { purchaseHelpers } from "../../../hooks/purchaseHooks"
import { useNavigate } from "react-router-dom"

export const PurchaseFormLoader = () => {
    const { dataType,  } = useRoutesHooks().parseUrl()
    const purchase = dataType as O<PurchaseOrder>

    const [ready, setReady] = useState(false)
    const [supplier, setSupplier] = useState<O<Supplier>>()

    const { isFixable } = purchaseHelpers
    const { describeCode } = operationHelpers
    const { getRoutePath } = useRoutesHooks()
    const navigate = useNavigate()

    const supplierLoaders = useSupplierLoaders()

    const { setDisableBranchSelector } = useUIStateActions()

    const load = async () => {
        if (purchase) {
            if (!isFixable(purchase)) {
                navigate(getRoutePath(RoutePath.PURCHASES, purchase.id))
            } else {
                const { loadSupplier } = supplierLoaders()
                const loadedSupplier = await loadSupplier(purchase.supplierId)
                setSupplier(loadedSupplier)
            }
        }
    }

    useEffect(() => {
        setDisableBranchSelector(true)
        load().then(() => setReady(true))
        return () => {
            setDisableBranchSelector(false)
        }
    }, [])

    const title = useMemo(() => `${purchase ? 'Editar' : 'Crear'} Compra${purchase ? ' ' + describeCode(purchase) : ''}`, [purchase])
    const crumbs = useGetCrumbs(
        'Compras',
        RoutePath.PURCHASES,
        purchase && describeCode(purchase),
        purchase?.id,
        purchase ? 'Editar' : 'Crear'
    )

    return (
        <PanelLoader
            title={title}
            crumbs={crumbs}
            ready={ready}
            wide
        >
            <PurchaseForm
                purchase={purchase}
                supplier={supplier}
            />
        </PanelLoader>
    )
}
